import type { ComputedRef } from 'vue'
import type { AppState } from '../models'
import { getCurrentInstance } from 'vue'
import { APP_CONSTS } from '../store/app/app.consts'
import { mapActions, mapGetters } from './utils'

export function useAppLoading(): {
  loading: ComputedRef<AppState['loading']>
  setLoading: (loading: boolean) => void
} {
  const ctx = getCurrentInstance()

  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }

  const { loading } = mapGetters(ctx.proxy.$store, APP_CONSTS.moduleName, {
    loading: APP_CONSTS.getters.loading,
  })

  const { setLoading } = mapActions(ctx.proxy.$store, APP_CONSTS.moduleName, {
    setLoading: APP_CONSTS.actions.setLoading,
  })

  return {
    loading,
    setLoading,
  }
}
